import React from "react";
import { Box, Typography } from "@mui/material";
import { memo } from "react";
import { QUIZ } from "@/theme/quizTokens";
import { quizAsset } from "@/components/quiz/shared/quizAssets";
import { FullBleed } from "../review/ReviewSections";

const COLUMNS = [
  { icon: "icon-din-british", size: { xs: 43, md: 73 }, label: "100% British meat" },
  { icon: "icon-din-cooked", size: { xs: 39, md: 73 }, label: "Gently cooked by hand for a meaty texture" },
  { icon: "icon-din-supplement", size: { xs: 37, md: 73 }, label: "Superfood nutrient blend for their joints" },
];

/**
 * "DIN DINS!" opening-offer band on the Choose Plan screen (Figma 1521:890):
 * Kuillo heading, three badge columns, the lavender "Verified 94% by All About
 * Dog Food" strip, and the closing Kuillo copy — on a warm beige full-bleed band.
 */
function PlanDinDins() {
  return (
    <FullBleed sx={{ bgcolor: "#e9dfd7", py: { xs: "40px", md: "48px" }, mt: { xs: "34px", md: "44px" } }}>
      <Box sx={{ maxWidth: 640, mx: "auto", px: "24px", textAlign: "center" }}>
        <Typography
          sx={{
            fontFamily: QUIZ.font.label,
            fontSize: { xs: 28, md: 42 },
            lineHeight: 1.15,
            color: QUIZ.color.ink,
            mb: { xs: "26px", md: "36px" },
          }}
        >
          Real food. Real difference.
        </Typography>

        {/* 3 badge columns */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: { xs: "24px", md: "48px" },
            mb: { xs: "26px", md: "30px" },
          }}
        >
          {COLUMNS.map((col) => (
            <Box key={col.icon} sx={{ width: { xs: 100, md: 198 } }}>
              <Box
                sx={{
                  height: { xs: 44, md: 76 },
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  mb: { xs: "8px", md: "12px" },
                }}
              >
                <Box
                  component="img"
                  src={quizAsset(col.icon)}
                  alt=""
                  sx={{ width: col.size, height: "auto", display: "block" }}
                />
              </Box>
              <Typography
                sx={{
                  fontFamily: QUIZ.font.label,
                  fontSize: { xs: 12.5, md: 17 },
                  lineHeight: 1.3,
                  color: QUIZ.color.ink,
                }}
              >
                {col.label}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Lavender verified strip */}
        <Box
          sx={{
            bgcolor: "#e8c4ff",
            borderRadius: "6px",
            px: "16px",
            py: "10px",
            display: "inline-block",
          }}
        >
          <Typography
            sx={{
              fontFamily: QUIZ.font.label,
              fontSize: { xs: 16, md: 18 },
              lineHeight: 1.2,
              color: QUIZ.color.ink,
              px: { xs: 0, md: "46px" },
              py: { xs: 0, md: "4px" },
            }}
          >
            Rated 94% by All About Dog Food
          </Typography>
        </Box>
      </Box>
    </FullBleed>
  );
}

export default memo(PlanDinDins);
